export default "__VITE_ASSET__0f4a4b2b__"